import { makeAutoObservable } from 'mobx';
import { toast } from 'react-toastify';
import { getTeams } from 'services/integrations/LinearHttpService';

export class LinearIntegrationStore {
  stores: any = {};
  integrationID: string = '';
  teams: any = [];

  constructor() {
    makeAutoObservable(this);
  }

  setStores(stores) {
    this.stores = stores;
  }

  setIntegrationID = (integrationID) => {
    this.integrationID = integrationID;
  };

  setTeams = (teams) => {
    this.teams = teams;
  };

  getTeams = async () => {
    try {
      const response = await getTeams({
        projectID: this.stores.projectStore.currentProject.id,
        integrationID: this.integrationID,
      });
      if (response.status === 200) {
        this.setTeams(response.data);
      }
    } catch (err: any) {
      toast.error('Something went wrong!');
    }
  };
}
